<header>
  <div class="container">
    <mat-toolbar color="primary" class="app-toolbar">
      <!-- Logo -->
      <div class="logo">
        <a routerLink="/" (click)="scrollTo('home')">
          <img src="assets/images/sb-logo.webp" alt="Logo" height="45"/>
        </a>
      </div>

      <!-- Navigation Links -->
      <nav class="nav-links">
        <a mat-button disableRipple routerLink="/" (click)="scrollTo('home')">{{"global.home" | translate}}</a>
        <a mat-button disableRipple routerLink="/" (click)="scrollTo('services')">{{"global.ourServices" | translate}}</a>
        <a mat-button disableRipple routerLink="/" (click)="scrollTo('technologies')">{{"global.technologies" | translate}}</a>
        <a mat-button disableRipple routerLink="/" (click)="scrollTo('customers')">{{"global.clients" | translate}}</a>
        <a mat-button disableRipple routerLink="/" (click)="scrollTo('contact-us')" class="contact">{{"global.contactUs" | translate}}</a>
      </nav>

      <div class="language-bar">
        <a aria-label="Switch to English" class="no-styles" [class.active]="lang === 'en'" (click)="switchLang('en')">EN</a>
        <a aria-label="Switch to Bulgarian" class="no-styles" [class.active]="lang === 'bg'" (click)="switchLang('bg')">BG</a>
      </div>
    </mat-toolbar>
  </div>
</header>
